<div class="tw:w-full tw:px-4">
  @if (showTutorReports) {
    <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:mt-6">
      <div class="tw:flex-1 tw:px-[15px]">
        <button type="button" class="btn btn-primary tw:float-left" (click)="backToSite()">Transfer to site</button>
      </div>
    </div>
  }
  <div class="tw:flex tw:flex-wrap tw:-mx-[15px]">

    @if (showTutorReports) {
      <div class="tw:flex-1 tw:px-[15px]">
        <tutor-reports></tutor-reports>
      </div>
    }
    @if (!showTutorReports) {
      <div class="tw:flex-1 tw:px-[15px]">
        <label>Authenticating...</label>
      </div>
    }

  </div>
</div>